import * as classNames from "classnames";
import * as React from "react";
import { alertsClasses as myClasses } from "src/controllers/alerts";

import { Classes } from "src/mpd-library";

import { Text } from "@blueprintjs/core";

import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { alertComposeActions } from "src/actions";

import { ChannelBox, ChannelBoxTypes } from "src/controllers/alerts/components";

import "./styles.css";

interface ISelectChannelsProps {
  iPaws?: any;
  twitter?: any;
  facebook?: any;
  spot?: any;
  isActive: boolean;
  onSelectChannelsBoxClicked: (
    id: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onSelectChannelsBoxListChange: (
    id: string,
    type: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onShowComposeBottomBar(show: boolean): void;
}

class SelectChannels extends React.Component<ISelectChannelsProps, {}> {
  public constructor(props: ISelectChannelsProps) {
    super(props);
    this.onSelectChannelsBoxClicked = this.onSelectChannelsBoxClicked.bind(
      this
    );
    this.onSelectChannelsBoxListChange = this.onSelectChannelsBoxListChange.bind(
      this
    );
  }

  public componentWillMount() {
    this.props.onShowComposeBottomBar(true);
  }

  public render() {
    const { isActive, spot, iPaws, twitter, facebook } = this.props;

    return (
      <div
        className={classNames(
          myClasses.ALERTS_CONTENT_COMPOSE_SELECT_CHANNELS,
          isActive && Classes.ACTIVE
        )}
      >
        <div className={myClasses.ALERTS_CONTENT_COMPOSE_CHANNEL_BOX_CONTAINER}>
          <Text className="alerts-content-compose-subtitle">
            SELECT PRIMARY CHANNELS
          </Text>
          <ChannelBox
            className={classNames('spot', spot.status && Classes.ACTIVE)}
            title="Spot Network"
            id={"spot"}
            description="Send to everyone inside your jurisdictional boundaries"
            name="compose-alert--channels--push"
            onItemClick={this.onSelectChannelsBoxListChange}
            onClick={this.onSelectChannelsBoxClicked}
          />
          <ChannelBox
            className={classNames('ipaws', iPaws.status && Classes.ACTIVE)}
            title="iPAWS"
            id={"iPaws"}
            description="Send to everyone inside your jurisdictional boundaries"
            name="compose-alert--channels--ipaws"
            type={iPaws.status && ChannelBoxTypes.detailed}
            list={iPaws.list}
            onItemClick={this.onSelectChannelsBoxListChange}
            onClick={this.onSelectChannelsBoxClicked}
          />
        </div>
        <div className={myClasses.ALERTS_CONTENT_COMPOSE_CHANNEL_BOX_CONTAINER}>
          <Text className="alerts-content-compose-subtitle">
            SECONDARY CHANNELS <span> (optional) </span>
          </Text>
          <ChannelBox
            className={classNames('twitter', twitter.status && Classes.ACTIVE)}
            title="Twitter"
            id={"twitter"}
            description="Send to everyone inside your jurisdictional boundaries"
            name="compose-alert--channels--twitter"
            type={twitter.status && ChannelBoxTypes.detailed}
            list={twitter.list}
            onItemClick={this.onSelectChannelsBoxListChange}
            onClick={this.onSelectChannelsBoxClicked}
          />
          <ChannelBox
            className={classNames('facebook', facebook.status && Classes.ACTIVE)}
            title="Facebook"
            id={"facebook"}
            description="Send to everyone inside your jurisdictional boundaries"
            name="compose-alert--channels--facebook"
            type={facebook.status && ChannelBoxTypes.detailed}
            list={facebook.list}
            onItemClick={this.onSelectChannelsBoxListChange}
            onClick={this.onSelectChannelsBoxClicked}
          />
        </div>
      </div>
    );
  }

  private onSelectChannelsBoxClicked(event: any) {
    const id = event.currentTarget.dataset.id;
    this.props.onSelectChannelsBoxClicked(id);
    // const selectChannels = Object.assign({}, this.state.selectChannels);
    // selectChannels.boxsActive[id] = !selectChannels.boxsActive[id];
    // this.setState({ selectChannels });
  }

  private onSelectChannelsBoxListChange(event: any) {
    event.stopPropagation();
    const id = event.currentTarget.dataset.id;
    const type = event.currentTarget.dataset.type;
    console.log(id, type, "clicked");
    this.props.onSelectChannelsBoxListChange(id, type);
  }
  // const selectChannels = Object.assign({}, this.state.selectChannels);
  // selectChannels.boxItemActive[type][id] = !selectChannels.boxItemActive[
  //   type
  // ][id];
  // this.setState({ selectChannels });
}

const mapStateToProps = (state: any) => {
  const { alerts } = state;
  const { composeData } = alerts;
  const { selectChannels } = composeData;
  const { spot, iPaws, twitter, facebook } = selectChannels;

  return {
    composeData,
    spot,
    iPaws,
    twitter,
    facebook
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    onSelectChannelsBoxClicked: bindActionCreators(
      alertComposeActions.onSelectChannelsBoxClicked,
      dispatch
    ),
    onSelectChannelsBoxListChange: bindActionCreators(
      alertComposeActions.onSelectChannelsBoxListChanged,
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectChannels);



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/select-channels/select-channels.tsx